import { createStore, createLogger } from 'vuex'
import organisations from './modules/organisations'
import services from './modules/services'
import fixtures from "@/Store/modules/fixtures";
import expenses from "@/Store/modules/expenses";
import supplierinvoice from "@/Store/modules/supplierinvoice";

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {
        organisations,
        services,
        fixtures,
        expenses,
        supplierinvoice
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
